var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app-bar',{staticClass:"fill-height",attrs:{"app":"","clipped-right":"","fixed":"","flat":""}},[_vm._t("page-fixed-header")],2)}
var staticRenderFns = []

export { render, staticRenderFns }